var _this = this;
export const convertOptionsToArray = options => {
  return Object.keys(options).map(selectKey => {
    return {
      value: selectKey,
      label: options[selectKey]
    };
  });
};
export const debouncePromise = function (fn) {
  let ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  let timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise((resolve, reject) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        Promise.resolve(fn.apply(_this, args)).then(data => resolve(data), error => reject(error));
      }, ms);
    });
  };
};